import { attach, createStore } from 'effector'

import { chatapi } from '../api'

export const loginFx = attach({ effect: chatapi.login })

export const $canSendMessages = createStore(false)
export const $canReactToMessages = createStore(false)
